import { WHATSAPP_URL } from "@/constants";
import { WhatsAppIcon } from "@/components/icons";

export const WhatsAppFloat = () => (
  <a
    href={WHATSAPP_URL}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Encomendar pelo WhatsApp"
    data-testid="whatsapp-floating-button"
    className="md:hidden fixed bottom-5 right-5 z-50 inline-flex items-center gap-2 rounded-full bg-[#25D366] px-4 py-3.5 text-white text-sm font-medium shadow-lg border-2 border-white transition-transform duration-200 active:scale-95"
  >
    <WhatsAppIcon className="w-5 h-5" />
    Encomendar
  </a>
);
